import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import OrdersTable from "../components/OrdersTable";
import { Grid, Box, Typography } from "@mui/material";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import FunctionsIcon from "@mui/icons-material/Functions";
import { useDispatch, useSelector } from "react-redux";
import {
  addUnprocessedOrder,
  fetchUnprocessedOrders,
  mergeOrderUpdate,
  updateOrder,
} from "../features/ordersSlice";
import { CircularProgress, Paper } from "@mui/material";

export default function DashboardPage() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);

  const {
    data: orders,
    loading,
    error,
  } = useSelector((state) => state.orders.unprocessed);
  const [highlightedId, setHighlightedId] = useState(null);

  const today = new Date();
  const todayOrders =
    orders?.filter((order) => {
      if (!order.created_at) return false;
      const createdAt = new Date(order.created_at);

      return (
        createdAt.getUTCFullYear() === today.getUTCFullYear() &&
        createdAt.getUTCMonth() === today.getUTCMonth() &&
        createdAt.getUTCDate() === today.getUTCDate()
      );
    }) || [];

  const stats = [
    {
      title: "إجمالي الطلبات",
      value: orders.length,
      icon: <FunctionsIcon fontSize="large" />,
      color: "#2e7d32",
    },

    {
      title: "عدد طلبات اليوم",
      value: todayOrders.length,
      icon: <EventNoteIcon fontSize="large" />,
      color: "#1976d2",
    },
    // {
    //   title: "الطلبات غير المعالجة",
    //   value: orders.length,
    //   icon: <PendingActionsIcon fontSize="large" />,
    //   color: "#ed6c02",
    // },
  ];

  useEffect(() => {
    dispatch(fetchUnprocessedOrders());

    // Polling every 2 seconds
    const interval = setInterval(() => {
      dispatch(fetchUnprocessedOrders());
    }, 5000);

    return () => clearInterval(interval);
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(fetchUnprocessedOrders());

  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_API_BASE_URL}/api/orders/events/`
  //   );

  //   eventSource.addEventListener("new_order", (event) => {
  //     const newOrder = JSON.parse(event.data);
  //     dispatch(addUnprocessedOrder(newOrder));
  //     setHighlightedId(newOrder.id);
  //   });

  //   eventSource.addEventListener("order_updated", (event) => {
  //     const updatedOrder = JSON.parse(event.data);
  //     dispatch(mergeOrderUpdate(updatedOrder));
  //     setHighlightedId(updatedOrder.id);
  //   });

  //   eventSource.onerror = (err) => {
  //     console.error("SSE error:", err);
  //   };

  //   return () => {
  //     eventSource.close();
  //   };
  // }, [dispatch]);

  useEffect(() => {
    if (highlightedId) {
      const timer = setTimeout(() => setHighlightedId(null), 2000);
      return () => clearTimeout(timer);
    }
  }, [highlightedId]);

  // if (loading) {
  //   return (
  //     <Paper sx={{ p: 4, textAlign: "center" }}>
  //       <CircularProgress />
  //     </Paper>
  //   );
  // }

  if (error) {
    return (
      <Paper sx={{ p: 4, textAlign: "center" }}>
        <Typography color="error">{error}</Typography>
      </Paper>
    );
  }

  return (
    <MainLayout>
      <Grid container spacing={3}>
        {stats.map((stat, index) => (
          <Grid item size={{ xs: 12, md: 6 }} key={index}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 3,
                borderRadius: 2,
                boxShadow: 3,
                bgcolor: "background.paper",
                minHeight: 120,
              }}
            >
              <Box sx={{ color: stat.color }}>{stat.icon}</Box>
              <Box textAlign="right">
                <Typography variant="h6" color="text.secondary">
                  {stat.title}
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {stat.value}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <OrdersTable
        title="الطلبات الواردة"
        orders={orders}
        highlightedId={highlightedId}
      />
    </MainLayout>
  );
}
